export const Bibliography = [
    // Header section
    { span: 6, height: "32px", classes: "marginTop-8" }, // Main header

    // References list - flat structure
    { span: 15, height: "60px", classes: "marginTop-8" }, // First reference item
    { span: 15, height: "60px", classes: "marginTop-8" }, // Second reference item
    { span: 15, height: "60px", classes: "marginTop-8" }, // Third reference item
    { span: 15, height: "60px", classes: "marginTop-8" }, // Fourth reference item
    { span: 15, height: "60px", classes: "marginTop-8" }, // Fifth reference item
]
